export default {
    appName: "WEB",
    ver: "1.2.3"
}